import { Card } from '@mui/material'
import React from 'react'
import CreateHistoryEntry from './CreateHistoryEntry'
import HistoryTable from './HistoryTable'
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const HistoryEntryUpdates = ({ PatientId, PatientHistoryEntries, CurrentUser }) => {
  return (

    <Card sx={{ padding: "1em", marginTop: "1em" }}>
      {(CurrentUser.userType == "Therapist" || ["Admin", "Owner", "HeadAccounting"].includes(CurrentUser.userType) && <CreateHistoryEntry PatientId={PatientId}/>)}
      
      {
        PatientHistoryEntries.length > 0 ?
          // <HistoryTable Entries={Session.getPatientHistoryEntries} /> :
          <HistoryTable Entries={PatientHistoryEntries} /> :
          <div>
            <MDBox>
              <MDTypography component="a" variant="button" color="text" fontWeight="medium">
                No History Entries
              </MDTypography>
            </MDBox>
          </div>
      }
    </Card>

  )
}

export default HistoryEntryUpdates